import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem } from 'polished';
import {
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
  IconImg,
  TextP,
} from '../../..';
import { __ } from 'react-i18n/lib';
import { StyledTitle } from './Description';
import { prop } from '../../../utilities';
import { getImagePath } from '../../../utilities/product';

interface Props {
  isOpen: boolean;
  articles?: any[];
}

function Reviews({ isOpen, articles }: Props) {
  const hasReviews = false;
  if (!articles || articles.length === 0) {
    return null;
  }

  return (
    <StyledFlexRow isOpen={isOpen}>
      {/* {hasReviews ? (
          <StyledTitle>{__('Články a Recenzie')}</StyledTitle>
        ) : (
          <StyledTitle>{__('Žiadne články')}</StyledTitle>
        )} */}
      <ContentWrapper>
        {articles.map(article => {
          return (
            <StyledLink
              key={prop(article, 'web_content_id')}
              to={`/${prop(article, 'data.0.url')}`}
            >
              <CMSContent>
                <CMSImage
                  alt={`${__('Obrázok článku')} ${prop(
                    article,
                    'data.0.name',
                  )}`}
                  src={getImagePath(
                    `media/${prop(
                      article,
                      'data.0.photogallery.0.document_path',
                    )}`,
                    { width: 80, height: 80 },
                    false,
                    false,
                    true,
                  )}
                />
                <CMSName>{prop(article, 'data.0.name')}</CMSName>
              </CMSContent>
            </StyledLink>
          );
        })}
      </ContentWrapper>
    </StyledFlexRow>
  );
}

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  ${({ theme }) => theme.mediab.m810`
    flex-direction: column;
  `}
`;

export const StyledFlexRow = styled(FlexRowCenterVertical)<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  padding: ${rem(56)};
  ${({ theme }) => theme.mediab.l925`
    padding: 0;
    padding-top: ${rem(32)};
  `}
`;

const StyledLink = styled(Link)`
  width: 33%;
  text-decoration: none;
  ${({ theme }) => theme.mediab.l925`
    width: 60%;
    margin: 0 auto;
  `}
  ${({ theme }) => theme.mediab.m600`
    width: 100%;
  `}
`;

export const Title = styled(TextP)`
  text-decoration: none;
  font-size: ${rem(24)};
  font-family: ${({ theme }) => theme.font.primary};
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${rem(28)};
  font-weight: 400;
  margin: 0;
  margin-top: ${rem(0)};
`;

export const TitleWrapper = styled(FlexRowCenterVertical)`
  margin-bottom: ${rem(24)};
`;

const CMSContent = styled(FlexRow)`
  margin: ${rem(0)} ${rem(16)} ${rem(16)} 0;
`;

const CMSImage = styled(IconImg)`
  width: ${rem(80)};
  height: ${rem(80)};
  margin-right: ${rem(16)};
  object-fit: cover;
  flex: 1 0 auto;
  border-radius: ${rem(4)};
`;

const CMSName = styled(TextP)`
  width: 100%;
  font-size: ${rem(16)};
  line-height: ${rem(24)};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: auto;
  font-family: ${({ theme }) => theme.font.primary};
  text-transform: uppercase;
`;

export { Reviews as DsiReviews };
